import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { CorporateNameInputMeta } from "@Shared/containers/form/commonMeta";

export interface ICustomerConsultationFormMeta {
  bank: FormInputMeta;
  customer: FormInputMeta;
  fromDate: FormInputMeta;
  toDate: FormInputMeta;

  schema: any;
}

const customerConsultationFormMeta = {} as ICustomerConsultationFormMeta;

customerConsultationFormMeta.bank = {
    ...CorporateNameInputMeta,
    name: "bank",
    type: "select",
    options: [
        { value: "1", label: "Banque 1" },
        { value: "2", label: "Banque 2" },
        { value: "3", label: "Banque 3" },
    ],
    label: "Banque",
};

customerConsultationFormMeta.customer = {
  name: "customer",
  type: "select",
  label: "Client",
  options: [
    { value: "1", label: "Client 1" },
    { value: "2", label: "Client 2" },
    { value: "3", label: "Client 3" },
  ],
  placeholder: "",
  validation: yup.string()
};

customerConsultationFormMeta.fromDate = {
  name: "fromDate",
  type: "date",
  label: "Date Du",
  placeholder: "",
  validation: yup.string()
};

customerConsultationFormMeta.toDate = {
  name: "toDate",
  type: "date",
  label: "Au",
  placeholder: "",
  validation: yup.string()
};

customerConsultationFormMeta.schema = yup.object().shape(getValidationSchema(customerConsultationFormMeta));

export default customerConsultationFormMeta;